import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface FilterState {
  searchValue: string
  maxDeltaLast: number
}

const initialState = {
  searchValue: '',
  maxDeltaLast: 10,
} satisfies FilterState as FilterState

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload ?? ''
    },
    setMaxDeltaLast(state, action: PayloadAction<number>) {
      state.maxDeltaLast = action.payload
    },
  },
})

export const { setSearchValue, setMaxDeltaLast } = filterSlice.actions
export default filterSlice.reducer
